import * as React from 'react'
import PropTypes from 'prop-types'
import Quote from '@/components/Block/Quote'
import QuoteCredits from '@/components/Block/QuoteCredits'

import {
  Container
} from './style'

const ArticleBlockQuote = ({
  author = '',
  quote = ''
}) => {
  return (
    <Container>
      <Quote content={ quote } />
      <QuoteCredits title={ author } />
    </Container>
  )
}

ArticleBlockQuote.propTypes = {
  author: PropTypes.string,
  quote: PropTypes.string
}

export default ArticleBlockQuote
